import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Answers } from "../../../../types";

type DerivePersonalisedCoverNoUpdatesArgs = {
  groupNames: string[];
  answers: Answers;
  visibility: VisibilityMap;
};

/**
 * Pure helper: derive answers and visibility when a personalised_cover group is set to "no"
 * For personalised_cover groups, child answers are DELETED (not set to 'no')
 */
export const derivePersonalisedCoverNoUpdates = ({
  groupNames,
  answers,
  visibility,
}: DerivePersonalisedCoverNoUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  const nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };

  for (const child of groupNames) {
    // Delete the answer entirely (don't set to 'no')
    delete nextAnswers[child];
    nextVisibility[child] = false;
  }

  return { answers: nextAnswers, visibility: nextVisibility };
};
